module.exports = __webpack_public_path__ + "static/media/btn_album_next2bdd05435c7dad4c5bbba20891123827.webp";